import { render, staticRenderFns } from "./BrandSelector.vue?vue&type=template&id=367b8549&scoped=true&"
import script from "./BrandSelector.vue?vue&type=script&lang=ts&"
export * from "./BrandSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSelector.vue?vue&type=style&index=0&id=367b8549&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b8549",
  null
  
)

export default component.exports